const fallbackPath = '/bcaf8002163e2eca1c4b2dc8efb5fcdc8e8ca92cd3171e7c136e0d5ad2111f7f';
const configuredPath = String(process.env.REACT_APP_ADMIN_ENTRY_PATH || fallbackPath).trim();

// A rota e configuravel para cada ambiente. Ela reduz descoberta casual, mas a
// autorizacao continua obrigatoria no backend e nao depende deste endereco.
export const adminPath = /^\/[a-zA-Z0-9_-]{32,}$/.test(configuredPath) ? configuredPath : fallbackPath;
export const adminLoginPath = `${adminPath}/login`;
export const adminPasswordSetupPath = `${adminPath}/auth/definir-senha`;
export const adminRoute = (suffix = '') => `${adminPath}${suffix ? `/${suffix.replace(/^\/+/, '')}` : ''}`;
